import axios from 'axios';
const axiosServices = axios.create({ baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3335/' });

axiosServices.interceptors.response.use(
  (response) => {
    if (response?.data?.success === true) {
      const respData = response.data.data;
      if (respData && respData.has_subscription === false && !window.location.href.includes('/admin/subscription')) {
        const userInfoStr = localStorage.getItem('userInfo');
        if (userInfoStr) {
          try {
            const userInfo = JSON.parse(userInfoStr);
            userInfo.subscription = false;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
          } catch (e) {
            console.error('Failed to update userInfo', e);
          }
        }
        window.location.pathname = '/admin/subscription';
      }
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401 && !window.location.href.includes('/login')) {
      window.localStorage.clear();
      window.location.pathname = '/login';
    }
    return Promise.reject((error.response && error.response.data) || 'Wrong Services');
  }
);

export default axiosServices;
